import { Flex, Tag } from "@jsq/ds/core";
import { capitalizeEachWord } from "~/utils/strings";
import { roleRenderer } from "./styles_vanilla.css";

export type RoleCellRendererProps = {
  value: string[];
  data: {
    isInvestingProfile: boolean;
  };
};

const ROLE_LABELS: Record<string, string> = {
  owner: "Owner",
  controller: "Controller",
  signatory: "Signatory",
  payment_beneficiary: "Payment Beneficiary",
  unassigned: "Unassigned",
};

const formatRoleValue = (value: string): string => {
  return ROLE_LABELS[value] || capitalizeEachWord(value.replace(/_/g, " "));
};

export const RoleCellRenderer = ({ value, data }: RoleCellRendererProps) => {
  const roles = value || [];
  const { isInvestingProfile } = data;

  return (
    <Flex className={roleRenderer} gap={2} alignItems="center">
      {isInvestingProfile && <Tag label="Investment Profile" />}
      {roles.map((role, index) => (
        <Tag key={index} label={formatRoleValue(role)} />
      ))}
    </Flex>
  );
};
